const roles = {
  OPERADOR:"operador", 
  // RRPP:"Rrpp", 
  REDIMIDOR:"redimidor", 
  DEFAULT:"default", 
  ADMIN:"admin", 
  SUPERADMIN:"superAdmin",
  DELIVERY:"delivery"
}

module.exports = roles


// WEBPACK FOOTER //
// ./src/config/RolesConstants.js